export class Check {
    name: string;
    grade: Grade;
    data: CheckData[];
}

export class CheckData {
    name: string;
    value: string;
}

export enum Grade {
    HINT = 'HINT',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
}
